import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg, ts } from "@/lib/api";
import { Panel, Th, Td, btn, field } from "@/components/ui-kit";

const TONE = { pending: "text-amber-300", approved: "text-green-300", rejected: "text-rose-300" };

const AdminCell = ({ r, items, load }) => {
  const [pick, setPick] = useState("");
  const [why, setWhy] = useState("");
  const go = (approve) => api.post(`/link-requests/${r.id}/resolve`, { approve, part_no: pick, reason: why })
    .then(() => { toast.success(approve ? `${r.customer_item} linked to ${pick}` : "Request rejected"); load(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <div className="flex flex-wrap items-center gap-2">
      <select value={pick} onChange={(e) => setPick(e.target.value)} className={`h-8 max-w-xs rounded-md px-2 text-xs ${field}`} data-testid={`link-req-pick-${r.id}`}>
        <option value="">Pick product…</option>{items.map((i) => <option key={i.part_no} value={i.part_no}>{i.part_no} - {i.ep_sku} - {i.description}</option>)}
      </select>
      <Button size="sm" disabled={!pick} onClick={() => go(true)} className={btn.primary} data-testid={`link-req-approve-${r.id}`}>Link</Button>
      <Input value={why} onChange={(e) => setWhy(e.target.value)} placeholder="Reason (if rejecting)" className={`h-8 w-40 text-xs ${field}`} data-testid={`link-req-reason-${r.id}`} />
      <Button size="sm" variant="ghost" onClick={() => go(false)} className={btn.ghost} data-testid={`link-req-reject-${r.id}`}>Reject</Button>
    </div>
  );
};

export const LinkRequestsPanel = ({ admin }) => {
  const [rows, setRows] = useState([]);
  const [items, setItems] = useState([]);
  const load = () => api.get("/link-requests").then((r) => setRows(r.data));
  useEffect(() => {
    load();
    if (admin) api.get("/items").then((r) => setItems(r.data.filter((i) => i.type !== "RM")));
  }, [admin]);
  const shown = admin ? rows.filter((r) => r.status === "pending") : rows;
  if (!shown.length) return null;
  return (
    <Panel title={admin ? `Link requests from PO upload users (${shown.length})` : "My link requests"} testId="link-requests-panel" className="mb-5">
      <div className="overflow-x-auto"><table className="w-full text-sm">
        <thead className="border-b border-slate-800"><tr><Th>Asked</Th><Th>Customer</Th><Th>Customer item</Th><Th>From PO</Th><Th>Note</Th><Th>{admin ? "Link to" : "Result"}</Th></tr></thead>
        <tbody className="divide-y divide-slate-800/70">{shown.map((r) => (
          <tr key={r.id} data-testid={`link-req-${r.id}`}>
            <Td className="whitespace-nowrap text-xs">{ts(r.created_at)}<div className="text-slate-500">{r.created_by}</div></Td>
            <Td className="text-xs">{r.partner_name}</Td>
            <Td><span className="font-mono">{r.customer_item}</span><div className="text-xs text-slate-400">{r.description}{r.gtin ? ` · GTIN ${r.gtin}` : ""}</div></Td>
            <Td className="font-mono text-xs">{r.po_number || "-"}</Td><Td className="text-xs">{r.note || "-"}</Td>
            <Td className="text-xs">{admin ? <AdminCell r={r} items={items} load={load} /> : <span className={TONE[r.status]} data-testid={`link-req-status-${r.id}`}>{r.status}{r.part_no ? ` → ${r.part_no} (SAP ${r.ep_sku})` : ""}{r.reason ? ` - ${r.reason}` : ""}</span>}</Td>
          </tr>))}</tbody>
      </table></div>
    </Panel>
  );
};
